import React from 'react';
import { Link } from 'react-router-dom';

const FreeQuoteButton =() =>{
    return <div>
        <a class="waves-effect waves-light btn-large brown darken-2" ><Link  class="yellow-text"to ='/Contact'>  Contact</Link></a>
    </div>
}
export default FreeQuoteButton;